import React from "react";
import usePermission from "@util/usePermission";

/**
 * Conditionally renders children when the current admin has the required permission(s).
 *
 * @param {{
 *   permission: string | string[],
 *   mode?: "all" | "any",
 *   fallback?: React.ReactNode,
 *   children: React.ReactNode,
 * }} props
 */
export default function Can({
  permission,
  mode = "all",
  fallback = null,
  children,
}) {
  const allowed = usePermission(permission, { mode });
  if (!allowed) return fallback;
  return <>{children}</>;
}
